import React from "react";
import { cn } from "~/utils";

export default React.forwardRef(function (
  { children, className, ...props },
  ref,
) {
  return (
    <button ref={ref} className={cn("react", className)} {...props}>
      {children}
    </button>
  );
});
